<template>
  <icon :name="`fa ${this.name}`" size="sm"/>
</template>

<script>
import { SERVICES } from '../constants/services'

export default {
  props: {
    service: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: SERVICES.DEFAULT.ICON_NAME
    }
  },
  mounted() {
    switch (this.service) {
      case SERVICES.LIGHT.SERVICE:
        this.name = SERVICES.LIGHT.ICON_NAME
        break
      case SERVICES.WATER.SERVICE:
        this.name = SERVICES.WATER.ICON_NAME
        break
      case SERVICES.MULTIPLE_ACCESSES.SERVICE:
        this.name = SERVICES.MULTIPLE_ACCESSES.ICON_NAME
        break
      case SERVICES.ELECTRICITY.SERVICE:
        this.name = SERVICES.ELECTRICITY.ICON_NAME
        break
      case SERVICES.HELMET.SERVICE:
        this.name = SERVICES.HELMET.ICON_NAME
        break
      case SERVICES.FENCE.SERVICE:
        this.name = SERVICES.FENCE.ICON_NAME
        break
      case SERVICES.SHED.SERVICE:
        this.name = SERVICES.SHED.ICON_NAME
        break
      case SERVICES.CONNECTIVITY.SERVICE:
        this.name = SERVICES.CONNECTIVITY.ICON_NAME
        break
      case SERVICES.MANAGER.SERVICE:
        this.name = SERVICES.MANAGER.ICON_NAME
        break
      case SERVICES.NO_INFORMATION.SERVICE:
        this.name = SERVICES.NO_INFORMATION.ICON_NAME
        break
      case SERVICES.CORRALS.SERVICE:
        this.name = SERVICES.CORRALS.ICON_NAME
        break
      case SERVICES.MULTIPLE_PADDOCKS.SERVICE:
        this.name = SERVICES.MULTIPLE_PADDOCKS.ICON_NAME
        break
      default:
        this.name = SERVICES.DEFAULT.ICON_NAME
        break
    }
  }
}
</script>
<style scoped>
</style>